import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledIsNotTemplate = styled(Box)(({ theme }) => ({
  padding: '4px 8px',
  fontSize: theme.fontSize.main,
  lineHeight: '20px',
  color: theme?.palette?.text?.txt_default,
}));
